import React from "react";
import { SwiperSlide, Swiper } from "swiper/swiper-react";
import { Navigation } from "swiper/modules";
import PageContainer from "../../components/PageContainer";
import "swiper/swiper.min.css";
import "swiper/modules/navigation.min.css";

import step1 from "../../images/help/tutorial_1.png";
import step2 from "../../images/help/tutorial_2.png";
import step3 from "../../images/help/tutorial_3.png";
import step4 from "../../images/help/tutorial_4.png";
import step5 from "../../images/help/tutorial_5.png";
import step6 from "../../images/help/tutorial_6.png";
import step7 from "../../images/help/tutorial_7.png";

const data = [
  {
    text: "در اولین گام جهت دریافت مشاوره حقوقی آنلاین از اپلیکیشن حقوقی لاوین در صفحه‌ی اصلی اپلیکیشن بر روی (درخواست جدید) کیک کنید.",
    image: step1,
  },
  { text: "انتخاب نوع خدمت", image: step2 },
  { text: "انتخاب دسته‌بندی مناسب", image: step3 },
  { text: "تکمیل فرایند خرید", image: step4 },
  { text: "پرداخت", image: step5 },
  {
    text: "لازم به ذکر است شما می‌توانید با انتخاب «پیشنهادات ویژه» در هزینه‌های خود صرفه جویی کنید.",
    image: step6,
  },
  {
    text: "پس از پرداخت باید منتظر باشید که یکی از وکلای متخصص لاوین به درخواست شما پاسخ دهند. به محض قبول درخواست از طرف وکیل، شما می‌توانید در صفحه‌ی چت اپلیکیشن مشخصات وکیل خو را مشاهده و پرسش‌های خود را با وکیل مطرح کنید.",
    image: step7,
  },
];

const Help = () => {

  return (
    <PageContainer
      classNames="help"
      headerProps={{
        right: "",
        link: "/menu",
        content: "راهنمای استفاده از اپلیکیشن",
      }}
    >
      <Swiper
        spaceBetween={10}
        slidesPerView={1}
        navigation={true}
        dir="rtl"
        className="help-swiper"
        modules={[Navigation]}
      >
        {data.map((item, i) => (
          <SwiperSlide key={i} className="help-swiper-slide">
            <img
              className="help-swiper-img"
              src={item.image}
              alt={`step-${i}`}
            />
            <div className="help-swiper-text">{item.text}</div>
          </SwiperSlide>
        ))}
      </Swiper>
    </PageContainer>
  );
};

export default Help;
